import {PromotedSponsorshipModuleController} from "../promoted-sponsorship-module.controller";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";
import {SponsorshipsDomainService} from "../../../domain/sponsorships/services/sponsorships.domain-service";
import {SponsorshipsRequestParams} from "../../../domain/sponsorships/models/sponsorships.request-params";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";

export class PromotedSponsorshipModuleFetchHandler extends FetchHandler {
  controller: PromotedSponsorshipModuleController;

  static injectables = [SponsorshipsDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): SponsorshipsRequestParams {
    const requestParams: SponsorshipsRequestParams = new SponsorshipsRequestParams();

    return requestParams;
  }

  async action() {
    if (!this.state.dataSource) {
      const dataSource = await super.fetch();

      await this.controller.action(ACTION_TYPES.populateData, {dataSource});
    }

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return this.state.dataSource;
  }
}
